import { render, staticRenderFns } from "./ContactProfile.vue?vue&type=template&id=1abec47c&scoped=true&"
import script from "./ContactProfile.vue?vue&type=script&lang=js&"
export * from "./ContactProfile.vue?vue&type=script&lang=js&"
import style0 from "./ContactProfile.vue?vue&type=style&index=0&id=1abec47c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abec47c",
  null
  
)

export default component.exports